export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
// export const Details = () => import('./LetterDetails');
